<template>
    <div class="hidden md:flex flex-wrap px-4">
        <div class="w-1/3 h-12">
            <slot name="left"></slot>
        </div>
        <div class="w-1/3 h-12">
            <slot name="center"></slot>
        </div>
        <div class="w-1/3 h-12">
            <slot name="right"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DesktopFooter'
}
</script>
